import TransferApplication from './TransferApplication';
export default TransferApplication;